// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__34oIV","tab":"Tabs_tab__1DC7J","tabActive":"Tabs_tabActive__1n3r5"};